;globalThis["_sentryRouteManifest"] = "{\"dynamicRoutes\":[{\"path\":\"/articles/:id/edit\",\"regex\":\"^/articles/([^/]+)/edit$\",\"paramNames\":[\"id\"],\"hasOptionalPrefix\":false},{\"path\":\"/products/:id\",\"regex\":\"^/products/([^/]+)$\",\"paramNames\":[\"id\"],\"hasOptionalPrefix\":false},{\"path\":\"/products/:id/edit\",\"regex\":\"^/products/([^/]+)/edit$\",\"paramNames\":[\"id\"],\"hasOptionalPrefix\":false}],\"staticRoutes\":[{\"path\":\"/\"},{\"path\":\"/account\"},{\"path\":\"/analytics/feedback\"},{\"path\":\"/articles\"},{\"path\":\"/articles/new\"},{\"path\":\"/billing\"},{\"path\":\"/categories\"},{\"path\":\"/import\"},{\"path\":\"/layouts\"},{\"path\":\"/media\"},{\"path\":\"/media/upload\"},{\"path\":\"/members\"},{\"path\":\"/organization-settings\"},{\"path\":\"/permissions\"},{\"path\":\"/products\"},{\"path\":\"/products/new\"},{\"path\":\"/reports\"},{\"path\":\"/reports/articles\"},{\"path\":\"/reports/search\"},{\"path\":\"/tags\"},{\"path\":\"/themes\"},{\"path\":\"/account/verify-email\"},{\"path\":\"/auth/forgot-password\"},{\"path\":\"/auth/reset-password\"},{\"path\":\"/invitations/accept\"},{\"path\":\"/login\"},{\"path\":\"/signup\"},{\"path\":\"/signup/verify\"}],\"isrRoutes\":[]}";globalThis["_sentryNextJsVersion"] = "16.4.1";import * as Sentry from "@sentry/nextjs";

Sentry.init({
  dsn: process.env["NEXT_PUBLIC_SENTRY_DSN"],
  environment: process.env["NEXT_PUBLIC_APP_ENV"] ?? "development",
  sendDefaultPii: false,
  // ブラウザ拡張機能が注入したスクリプトのエラーはこちらのコードで直しようがないため除外する
  denyUrls: [
    /extensions\//i,
    /^chrome-extension:\/\//i,
    /^moz-extension:\/\//i,
    /^safari-web-extension:\/\//i,
  ],
  ignoreErrors: ["Script error.", "top.GLOBALS", "ResizeObserver loop limit exceeded"],
  beforeSend(event, hint) {
    const error = hint.originalException;
    const status =
      error && typeof error === "object" && "status" in error ? error.status : undefined;
    // 5xx・ステータス不明なものは Sentry に送る。
    if (typeof status !== "number" || status >= 500) {
      return event;
    }
    return null;
  },
});

export const onRouterTransitionStart = Sentry.captureRouterTransitionStart;
